// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-modal > *:not(:last-child) {
  margin-bottom: 25px;
}

.custom-modal .modal__actions {
  text-align: center;
}
.custom-modal .modal__actions .button {
  border-radius: 24px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 700;
  line-height: 24px;
  min-width: 150px;
}
.custom-modal .modal__actions .button:not(:last-of-type) {
  margin-right: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/auth/protected/session-expire-modal/session-expire-modal.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".custom-modal > *:not(:last-child) {\n  margin-bottom: 25px;\n}\n\n.custom-modal .modal__actions {\n  text-align: center;\n}\n.custom-modal .modal__actions .button {\n  border-radius: 24px;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 24px;\n  min-width: 150px;\n}\n.custom-modal .modal__actions .button:not(:last-of-type) {\n  margin-right: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
